import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { inOutAnimation } from '@shared/animations';
import { AuthService } from '@shared/services/auth.service';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'pop-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.less'],
  animations: [inOutAnimation]
})
export class UserCardComponent extends BaseComponent implements OnInit, OnDestroy {
  public showUserCard = false;
  public name: string;
  public company: string;
  public languageCode: string;

  @ViewChild('userCardButton', { static: true })
  public userCardButton: ElementRef<HTMLElement>;
  @ViewChild('userCard', { static: false })
  public userCard: ElementRef<HTMLElement>;

  public constructor(
    private authService: AuthService,
    private userService: UserService
  ) {
    super();
  }

  public ngOnInit() {
    this.subscribe(
      this.userService.getUser().subscribe(user => {
        this.name = user?.name;
        this.company = user?.company;
        this.languageCode = user?.languageCode;
      })
    );
  }

  public async goToLogout() {
    await this.authService.logout();
  }

  public toggleUserCard() {
    this.showUserCard = !this.showUserCard;
  }

  public async changeLanguage(languageCode: string) {
    await this.userService.updateLanguage(languageCode);
    this.languageCode = languageCode;
  }

  public closeUserCard() {
    this.showUserCard = false;
  }
}
